import { BREAKPOINT } from '@/modules/api'
import './InfoWindow.scss'

export default class InfoWindow {
  setMaxWidth (small = 143, large = 167) {
    return window.innerWidth < BREAKPOINT.TABLET ? small : large
  }

  setPixelOffset () {
    return window.innerWidth < BREAKPOINT.TABLET ? new google.maps.Size(0, 0) : new google.maps.Size(50, 0)
  }

  /**
   * 
   * @param {Object} region
   * @returns {Element} html <div> with string template
   */
  getContentTemplate (region) {
    const template =
      `${'<div class="regionInfoWrapper">' +
        '<div class="regionPhoto" height="100px" style="background: url('}${region.MiniatureUrl}); height: 100px;"></div>` +
        `<div class="regionInfo">${region.Description}</div>` +
      '</div>'

    return template
  }

  getInfoWindow (options) {
    return new google.maps.InfoWindow(options)
  }

  styleInfoWindow () {
    const windowBg = document.querySelector('.gm-style-iw').previousElementSibling
    const windowCloseButton = document.querySelector('.gm-style-iw').nextElementSibling

    windowBg.parentElement.classList.add('infowindowStyles')
    windowBg.style.display = 'none'
    windowCloseButton.style.display = 'none'
  }
}


// WEBPACK FOOTER //
// ./src/components/googleMap/integration/InfoWindow.js